import TableCellLabels from "ds/components/Table/Row/CellLabels";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { VcsIntegration } from "types/generated";

const VCSIntegrationsTableLabelsCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<VcsIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLabels tags={integration.labels} />
    </TableSimpleCell>
  );
};

export default VCSIntegrationsTableLabelsCell;
